// Navigation
jQuery(function ($) {
	let set = window.innerWidth > 1000;
	$('.js-nav').hover(function () {
		if (set) {
			$(this).addClass('active');
			$(this).find('.l-nav__sub-menu').stop().fadeIn(300);
		}

	}, function () {
		if (set) {
			$(this).removeClass('active');
			$(this).find('.l-nav__sub-menu').stop().fadeOut(300);
		}
	});

	document.querySelectorAll('.js-nav__spTrigger').forEach(trigger => {
		if (trigger.nextElementSibling.classList.contains('js-nav__spTarget')) {
			trigger.addEventListener('click', function (e) {
				if (!set) {
					e.preventDefault();
					e.stopPropagation();
					const trgr = e.target.closest('.js-nav__spTrigger');
					const wrapper = trgr.closest('.js-nav')
					const target = wrapper.querySelector('.js-nav__spTarget');

					if (wrapper.classList.contains('active')) {
						wrapper.classList.remove('active');
						jQuery(target).stop().slideUp();
					} else {
						wrapper.classList.add('active');
						jQuery(target).stop().slideDown();
					}
				}


			}, false);
		}
	});

	window.addEventListener('resize', function (e) {
		set = window.innerWidth > 1000;
	});
});

